import FeedbackTransition from '../../components/molecules/feedbacks/FeedbackTransition.vue'

export default {
  components: { FeedbackTransition }
}
